import { FaWhatsapp } from "react-icons/fa";
import { Mail, Phone } from "lucide-react";
import { BRAND, whatsappLink } from "@/config";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0a0a0a]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-3xl font-extrabold tracking-tight text-white">
                NG<span className="text-[#0052ff]">M</span>
              </span>
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[#94a3b8]">
              {BRAND.tagline}
            </p>
            <p className="mt-4 max-w-xs text-sm text-[#52525b]">
              Fahrdienste, Überführungen, Reinigung & Pflege sowie Hol- und
              Bringservice für Ihr Fahrzeug.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#94a3b8]">
              Navigation
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href="#leistungen" className="text-[#cbd5e1] hover:text-white transition-colors">
                  Leistungen
                </a>
              </li>
              <li>
                <a href="#ueber-uns" className="text-[#cbd5e1] hover:text-white transition-colors">
                  Über uns
                </a>
              </li>
              <li>
                <a href="#kontakt" className="text-[#cbd5e1] hover:text-white transition-colors">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#94a3b8]">
              Kontakt
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-[#cbd5e1] hover:text-white transition-colors">
                  <Mail className="h-4 w-4 text-[#0052ff]" /> {BRAND.email}
                </a>
              </li>
              <li>
                <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-[#cbd5e1] hover:text-white transition-colors">
                  <Phone className="h-4 w-4 text-[#0052ff]" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#cbd5e1] hover:text-white transition-colors">
                  <FaWhatsapp className="h-4 w-4 text-[#25D366]" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-[#52525b]">
            © {year} {BRAND.full}. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
